<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><em class="italic">For Allan<br/>a wandering minstrel, he!</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedi.vue?7ffa3e5c